/* ============
 * Module Transformer
 * ============
 */

import Transformer from './transformer';

export default class ModuleTransformer extends Transformer {

  static fetch(module) {
    return {
      id: module.id,
      name: module.name,
      group: module.group,
      type: module.type,
      subscribe: module.subscribe,
      fields: module.fields,
      component: module.component,
      price: module.price,
      description: module.description,
      requested: module.requested,
      disabled: module.disabled,
      allowUpdate: module.allowUpdate,
    };
  }

  static send(module) {
    return {
      id: module.id,
      name: module.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/module.js